// @flow
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useMediaQuery } from 'react-responsive';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import IntroCard from 'components/molecules/introductionCard';
import { PaginationControl } from 'components/molecules/paginationControl';
import { useViewport } from 'components/templates/viewportProvider';
import { RouteNames } from 'router';
import './style.scss';

type Props = {
  theme: string,
};

const TeamPage = (props: Props) => {
  const { isMobile, height } = useViewport();
  const [sliderRef, setSlider] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const isTablet = useMediaQuery({
    query: '(max-width: 1250px) and (min-width: 568px)',
  });

  if (!props) {
    return null;
  }
  let { type, cmsDetailsData } = props.data;
  let data;
  type === 'About' ? (data = props.data.teamData) : (data = props.data);
  const show_desktop_overlay_button = props.data.show_desktop_overlay_button;
  const handleSliderRef = ref => {
    setSlider(ref);
  };

  const next = () => {
    sliderRef.slickNext();
  };

  const previous = () => {
    sliderRef.slickPrev();
  };

  const lengthOfSliders =
    data[0] && data[0].testimonial_clients
      ? data[0].testimonial_clients.length < 3
        ? 2
        : data[0].testimonial_clients.length
      : '';
  const description_trim_length_mobile = 3;
  const toggleButton = props.location.pathname !== RouteNames.about;
  return (
    <div
      className="team-container"
      style={isMobile ? { height } : {}}
      id={'team'}
    >
      <Row>
        <Col xs={{ span: 11 }} md={{ span: 4, offset: 0 }} className="column">
          {data &&
            data.map((item, idx) => (
              <IntroCard
                data={item}
                description_trim_length_mobile={description_trim_length_mobile}
                key={idx}
                showJoinButton={toggleButton}
                join_team_link={item.join_team_link}
              />
            ))}
        </Col>
        <Col md={{ span: 8, offset: 0 }}>
          <div className={'slider'}>
            {!isMobile ? (
              data && data[0] ? (
                <HorizontalCarousel
                  data={data[0]}
                  detailsPage={cmsDetailsData}
                  mediaPath={data[0]}
                  type={isTablet ? 'teamTablet' : 'team'}
                  cssFor={'team'}
                  getActiveSlide={e => {
                    setActiveSlide(e);
                  }}
                  handleSliderRef={handleSliderRef}
                  showOverlay={show_desktop_overlay_button}
                />
              ) : null
            ) : data && data[0] ? (
              <HorizontalCarousel
                data={data[0]}
                detailsPage={cmsDetailsData}
                mediaPath={data[0]}
                type={'teamMobile'}
                showOverlay={show_desktop_overlay_button}
                cssFor="Carousel_Team"
              />
            ) : null}
          </div>
        </Col>
      </Row>
      {!isMobile ? (
        <div className="section-footer show-explore">
          <PaginationControl
            className={'section-footer-item'}
            theme={'dark-theme'}
            mode={'slider'}
            currentIndex={activeSlide + 1}
            total={lengthOfSliders}
            onNextClick={next}
            onPreviousClick={previous}
            key={'17'}
          />
        </div>
      ) : null}
    </div>
  );
};
export default withRouter(TeamPage);
